// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1kDAK","signatureButtonsRight":"ModalSign_signatureButtonsRight__1l0Nb"};